var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PerfectScrollbar',{ref:"perfectScrollbar",attrs:{"tag":_vm.htmlTag,"options":_vm.options},on:{"ps-y-reach-end":function($event){return _vm.$emit('rollToTheBottom')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }